// The key stays a literal at each call: the persistence manifest script only
// records raw Web Storage keys it can read at the call site.

export const writeTeamJoinBootNote = (): void => {
  if (typeof globalThis.sessionStorage === 'undefined') return;
  try {
    globalThis.sessionStorage.setItem('heidi-team-join:boot-after-join:v1', '1');
  } catch {
    // Storage unavailable: the boot takes its ordinary path.
  }
};

export const consumeTeamJoinBootNote = (): boolean => {
  if (typeof globalThis.sessionStorage === 'undefined') return false;
  try {
    const isSet =
      globalThis.sessionStorage.getItem('heidi-team-join:boot-after-join:v1') !== null;
    if (isSet) globalThis.sessionStorage.removeItem('heidi-team-join:boot-after-join:v1');
    return isSet;
  } catch {
    return false;
  }
};
